import React, { Component } from 'react'
import Topnavbar from '../components/topnavbar/Topnavbar'
import Pagetop from '../components/Pagetop/Pagetop'
import Donate from '../components/Donate/Donate'
import Footer from '../components/Footer/Footer'

class Donatepage extends Component {
    componentDidMount(){
        window.scroll(0,0)
    }
  render() {

    return (
      <div>
        <Topnavbar title="Donate"/>
        <Pagetop title="Donate"/>
        <Donate/>
        <Footer/>
      </div>
    )
  }
}

export default Donatepage
